import api from "./api";
import { ApiResponse } from "./auth.service";
import { EmployerJobPostPayload } from "./types";

export const getLatestVacancies = (limit: number = 9, jobTypeId: string = "", mdRankId: string = ""): ApiResponse<any> => api.get("/vacancies/latest?limit=" + limit + "&job_type_id=" + jobTypeId + "&md_rank_id=" + mdRankId).then(res => res.data);

export const getLatestJobs = (limit: number = 9, jobTypeId: string = "", mdRankId: string = ""): ApiResponse<any> => api.get("/employers/jobs/latest?limit=" + limit + "&job_type_id=" + jobTypeId + "&md_rank_id=" + mdRankId).then(res => res.data);

export const postJobs = (payload: EmployerJobPostPayload): ApiResponse<any> => api.post("/employers/jobs", payload).then(res => res.data);

export const snakeToTitleCase = (value: string | undefined) => {
  if (!value) return "";

  return value
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export const toTitleCase = (str: string) => {
  if (!str) return "";
  return str
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const safeApiCall = async <T>(
  apiCall: () => Promise<T>,
  onSuccess: (data: T) => void
) => {
  try {
    const response = await apiCall();
    onSuccess(response);
  } catch (error: any) {
    console.log(error);
  }
};
